export class Client {
  _id:string = '';
  name:string = '';
  contactName:string = '';
  contactPhone:string = '';
  contactEmail:string = '';
  
  getId() {
    return this._id;
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/client/client.model.ts